<template>
  <div v-if="seller">
    <div class="py-2 flex flex-col">
      <div class="text-lg text-bold font-serif text-center border-b border-secondary-300 pb-2">
        <span v-if="checkBirthday()">{{ $t('seller_dashboard_page.happy_birthday') }} </span>
        <span v-else>{{ $t('seller_dashboard_page.welcome') }} </span>
        {{ seller.name }}
      </div>
    </div>

    <div class="flex flex-wrap mt-3">
      <div class="w-full lg:w-1/5 lg:pr-3">
        <router-link tag="div" to="/sales-dashboard" class="flex flex-col items-center px-4 py-3 mt-2 text-center cursor-pointer hover:bg-primary-100 transition-all duration-300">
          <BaseIcon icon="dollar-sign" class="text-6xl" />
          <div class="font-semibold font-serif mt-3">{{ $t('seller_dashboard_page.your_sales') }}</div>
        </router-link>
      </div>
      <div class="w-full lg:w-1/5 lg:pr-3">
        <router-link tag="div" to="/admin/staff" class="flex flex-col items-center px-4 py-3 mt-2 text-center cursor-pointer hover:bg-primary-100 transition-all duration-300">
          <BaseIcon icon="id-card" class="text-6xl" />
          <div class="font-semibold font-serif mt-3">{{ $t('seller_dashboard_page.staff') }}</div>
        </router-link>
      </div>
      <div class="w-full lg:w-1/5 lg:pr-3">
        <router-link tag="div" to="/company-info" class="flex flex-col items-center px-4 py-3 mt-2 text-center cursor-pointer hover:bg-primary-100 transition-all duration-300">
          <BaseIcon icon="info-circle" class="text-6xl" />
          <div class="font-semibold font-serif mt-3">{{ $t('seller_dashboard_page.info') }}</div>
        </router-link>
      </div>
      <div class="w-full lg:w-1/5 lg:pr-3">
        <router-link tag="div" to="/admin/avtal" class="flex flex-col items-center px-4 py-3 mt-2 text-center cursor-pointer hover:bg-primary-100 transition-all duration-300">
          <BaseIcon icon="file-alt" class="text-6xl" />
          <div class="font-semibold font-serif mt-3">{{ $t('seller_dashboard_page.agreements') }}</div>
        </router-link>
      </div>
      <div class="w-full lg:w-1/5 lg:pr-3">
        <router-link tag="div" to="/admin/kunder" class="flex flex-col items-center px-4 py-3 mt-2 text-center cursor-pointer hover:bg-primary-100 transition-all duration-300">
          <BaseIcon icon="users" class="text-6xl" />
          <div class="font-semibold font-serif mt-3">{{ $t('seller_dashboard_page.customers') }}</div>
        </router-link>
      </div>
    </div>

    <div class="flex flex-wrap mt-6">
      <div class="w-full lg:w-1/2 lg:pr-3 mt-2">
        <News />
      </div>
      <div class="w-full lg:w-1/2 lg:pr-3 mt-2">
        <Links />
      </div>
    </div>
  </div>
</template>

<script>
import News from "@/components/news";
import Links from "@/components/link";

export default {
  name: "DashboardSeller",
  title() {
    return `${this.$t('seller_dashboard_page.page_title')} | SecurCloud`;
  },
  components: {
    News,
    Links,
  },
  data() {
    return {
      user: this.$store.state.user,
      seller_id: this.$route.params.id,
      seller: null,
    };
  },
  methods: {
    async getSellerDashboard() {
      try {
        let response = await this.axios.get(`${process.env.VUE_APP_SERVER_URL}/dashboard/seller/${this.seller_id}`);
        this.seller = response.data.seller;

        this.setPageTitle(`${this.seller.name} - ${this.$t("top_titles.dashboard")}`, "seller_dashboard");
      } catch (error) {
        this.handleError(error);
      }
    },

    checkBirthday() {
      if(this.seller.birth_date){
        const today = this.moment();
        const birthDate = this.moment(this.seller.birth_date);

        return today.month() === birthDate.month() && today.date() === birthDate.date();
      }
      return false;
    },

    currency: function(value) {
      if (!value) return "";
      return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") + " kr";
    },
  },

  created() {
    this.getSellerDashboard();
  },
};
</script>
